import { Card, CardContent, CardHeader, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface OwnProps {
  className?: string;
}

const PhoneSupportCard: React.FunctionComponent<OwnProps> = ({ className }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Card className={className}>
      <CardHeader title={t('app:help.supportPhoneTitle')} />
      <CardContent className={classes.cardContent}>
        <div className={classes.cardContentItem}>
          <strong>UK</strong>
          <Typography className={classes.typography}>{t('app:help.phoneUK')}</Typography>
          <Typography className={classes.typography}>{t('app:help.streetUK')}</Typography>
          <Typography className={classes.typography}>{t('app:help.cityUK')}</Typography>
          <Typography className={classes.typography}>{t('app:help.countryUK')}</Typography>
        </div>

        <strong>USA</strong>
        <Typography className={classes.typography}>{t('app:help.phoneUS')}</Typography>
        <Typography className={classes.typography}>{t('app:help.streetUS')}</Typography>
        <Typography className={classes.typography}>{t('app:help.cityUS')}</Typography>
        <Typography className={classes.typography}>{t('app:help.countryUS')}</Typography>
      </CardContent>
    </Card>
  );
};

const useStyles = makeStyles((theme) => ({
  cardContent: {
    '& p': {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(4),
    },
  },
  cardContentItem: {
    paddingBottom: theme.spacing(6),
  },
  typography: {
    lineHeight: 1,
  },
}));

export default PhoneSupportCard;
